<template>
  <v-card class="mx-auto my-12" max-width="374">
    <v-toolbar color="blue-grey darken-1" dark flat>
      <v-toolbar-title>LeanCMS Login</v-toolbar-title>
    </v-toolbar>
    <v-form v-model="valid" class="pa-5" @submit.prevent="login">
      <v-text-field v-model="username" :rules="rules" outlined label="Username" required></v-text-field>
      <v-text-field
        v-model="password"
        :rules="rules"
        outlined
        label="Password"
        required
        type="password"
        :hint="forgotPassword"
        persistent-hint
      >
        <template v-slot:message="{ message, key }">
          <span v-html="message" class="ml-n2"></span>
        </template>
      </v-text-field>
      <v-btn type="submit" class="blue-grey white--text" block>Login</v-btn>
      <div class="caption mt-3 text-center">
        If you have received an invitation, you will need to<br />
        <a :href="authUrl">set your initial password</a>.
      </div>
    </v-form>
  </v-card>
</template>

<script>
import { mapMutations, mapState, mapActions } from 'vuex';

export default {
  name: 'LeanLogin',
  data: () => ({
    valid: false,
    username: '',
    password: '',
    rules: [(v) => !!v || 'Required']
  }),
  mounted() {
    // if (typeof this.$route.query.reset !== 'undefined') {
    //   window.location = `https://auth.${this.awsExports.domain}/confirmForgotPassword?client_id=${this.awsExports.Auth.userPoolWebClientId}&response_type=code&scope=aws.cognito.signin.user.admin+email+openid+phone+profile&redirect_uri=https://admin.${this.awsExports.domain}`;
    // }
  },
  computed: {
    ...mapState({
      snackbar: (state) => state.snackbar,
      awsExports: 'awsExports'
    }),
    authUrl() {
      return `https://auth.${this.awsExports.domain}/login?client_id=${this.awsExports.Auth.userPoolWebClientId}&response_type=code&scope=aws.cognito.signin.user.admin+email+openid+phone+profile&redirect_uri=https://admin.${this.awsExports.domain}`;
    },
    forgotPassword() {
      return `<a href='${this.forgotPasswordUrl}'>Forgot password</a>`;
    },
    forgotPasswordUrl() {
      return `https://auth.${this.awsExports.domain}/forgotPassword?client_id=${this.awsExports.Auth.userPoolWebClientId}&response_type=code&scope=aws.cognito.signin.user.admin+email+openid+phone+profile&redirect_uri=https://admin.${this.awsExports.domain}`;
    }
  },
  methods: {
    ...mapActions('cognito', ['signInUser']),
    ...mapMutations({
      setSnackbar: 'setSnackbar',
      setEmail: 'setEmail',
      setPassword: 'setPassword',
      setIsLoading: 'setIsLoading'
    }),
    login() {
      this.setEmail(this.username);
      this.setPassword(this.password);
      this.signInUser({
        username: this.username,
        password: this.password
      })
        .then(() => {
          this.setSnackbar({
            message: `Successfully signed in user ${this.username}`
          });
          this.setEmail('');
        })
        .catch((res) => {
          this.setSnackbar({
            error: 'error',
            message: res.message
          });
        })
        .finally(() => {
          this.setIsLoading(false);
          this.setPassword('');
        });
    }
  }
};
</script>
